import React, { Fragment } from 'react';
import cls from 'classnames';

import MastercardIcon from '@ott/icon-mastercard';
import VisaIcon from '@ott/icon-visa';
import MirIcon from '@ott/icon-mir';
import GooglePayIcon from '@ott/icon-google-pay';
import AmexIcon from '@ott/icon-amex-logo';
import PaypalIcon from '@ott/icon-paypal';
import ApplePayIcon from '@ott/icon-apple-pay';
import TwelveMonthPaymentByInstalments from '@ott/icon-twelve-month-payment';

import styles from './PaySystems.scss';
import { Lang } from '../../../../Footer';

type Props = {
  lang: Lang;
};

const PaySystems = ({ lang }: Props) => {
  switch (lang) {
    case 'ru':
      return (
        <Fragment>
          <MastercardIcon className={styles.icon} />
          <VisaIcon className={styles.icon} />
          <MirIcon className={styles.icon} />
          <GooglePayIcon className={cls(styles.icon, styles.iconWhite)} />
          <ApplePayIcon className={cls(styles.icon, styles.iconWhite)} />
          <TwelveMonthPaymentByInstalments className={cls(styles.icon, styles.iconWhite)} />
          <AmexIcon className={styles.icon} />
        </Fragment>
      );
    case 'uk-ua':
    case 'ru-ua':
    case 'pl':
    case 'tr':
    case 'ru-by':
      return (
        <Fragment>
          <MastercardIcon className={styles.icon} />
          <VisaIcon className={styles.icon} />
        </Fragment>
      );
    case 'en-us':
      return (
        <Fragment>
          <MastercardIcon className={styles.icon} />
          <VisaIcon className={styles.icon} />
          <AmexIcon className={styles.icon} />
        </Fragment>
      );
    case 'en-gb':
      return (
        <Fragment>
          <MastercardIcon className={styles.icon} />
          <VisaIcon className={styles.icon} />
          <AmexIcon className={styles.icon} />
          <PaypalIcon className={styles.icon} />
        </Fragment>
      );
    case 'de':
    case 'en-ie':
    case 'es':
      return (
        <Fragment>
          <MastercardIcon className={styles.icon} />
          <VisaIcon className={styles.icon} />
          <AmexIcon className={styles.icon} />
        </Fragment>
      );
    default:
      return (
        <Fragment>
          <MastercardIcon className={styles.icon} />
          <VisaIcon className={styles.icon} />
        </Fragment>
      );
  }
};

export default PaySystems;
